import React, { useState, useEffect, useRef } from "react";
import * as r from "../../constants/routes";
import pClasses from "./Profile.module.scss";
import { useNavigate } from "react-router";
import MuiDialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faArrowRight,
  faLock,
  faLockOpen,
  faTimes,
  faTrashAlt,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";

import { User } from "../../interfaces/User";
import Spinner from "../Spinner";
import useFetch from "../../hooks/useFetch";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
import RoundButton from "../Buttons/RoundButton";
import { useTranslation } from "react-i18next";
import {
  API_USERS_ACTIVE,
  // API_USERS_GROUPS_AUDIOFOCO,
  GET_API_TESTS,
  API_USERS_REMOVE,
  DELETE_API_USERS,
  API_USER_RESEND_PASSWORD,
  SECRET_KEY,
  AUDIOFOCO_LINK,
  UPDATE_USER_GROUP,
} from "../../constants/api";
import Crypto from "crypto-js";
import { R_A_REPORT_SMART } from "../../constants/routes";

interface Interface {
  userProfile: any;
  openProfile: any;
  groupsUsers: any;
  open: any;
  onCloseModal: any;
  updateCalback: any;
}

export default function Profile({
  userProfile,
  groupsUsers,
  open,
  onCloseModal,
  updateCalback,
}: Interface) {
  const [userInfos, setuserInfos] = useState(Object);
  const newUserGroup = useRef<any>("");
  const [userGroupName, setUserGroupName] = useState<any>(
    userInfos?.group_name
  );
  const [mailArea, setmailArea] = useState(<></>);
  const [optionsGroups, setOptionsGroups] = useState([]);
  const [sending, setSending] = useState(false);
  const isLoadingGroup = useRef(false);
  const [isEmailSend, setIsEmailSend] = useState<string | null>(null);
  const [userStatusblock, setuserStatusblock] = useState<any | null>(null);
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  const history = useNavigate();
  const { t } = useTranslation();
  const [, , , fetchToggle]: any = useFetch({
    autoInit: false,
  });
  const [, , , fetchUserGroup]: any = useFetch({
    autoInit: false,
  });

  // const [newGroupsUsers, isloading, , groupsUsersFetch]: any = useFetch({
  //   autoInit: false,
  // });
  const [, , , GetUserJourneysInfo]: any = useFetch({
    autoInit: false,
  });

  const handlerUserGroup = (newGroup: any) => {
    newUserGroup.current = newGroup;
  };

  useEffect(() => {
    if (userProfile?.formattedValue) {
      setuserStatusblock(userProfile.formattedValue.active);
      setuserInfos({ ...userProfile.formattedValue, ...userProfile.row });
    }
    if (userInfos.uid)
      GetUserJourneysInfo({
        url: GET_API_TESTS(userInfos.uid),
      });
  }, [userProfile]);

  const getUsersJsonPermission = () => {
    const relat = new URL(window.location.href);
    let caixa = [] as Array<any>;
    caixa = relat.pathname.split("/").reverse();
    let visto: string | null = null;
    if (caixa[0] === "go") {
      visto = "01";
    } else {
      visto = "10";
    }
    return visto;
  };

  const insertGroup = (e: any) => {
    e.preventDefault();
    if (isLoadingGroup.current) return alert("Carregando...");
    isLoadingGroup.current = true;
    const groupInfo = groupsUsers?.find(
      (group: any) => String(group.name) === String(newUserGroup.current)
    );
    if (userGroupName === newUserGroup.current) {
      isLoadingGroup.current = false;
      return alert("Esse já é o grupo do usuário.");
    }
    if (groupInfo?.name && groupInfo?.id)
      fetchUserGroup({
        method: "POST",
        url: UPDATE_USER_GROUP,
        data: {
          group_name: groupInfo?.name,
          group_uid: groupInfo?.id,
          user_uid: userInfos?.uid,
        },
        onSuccess: () => {
          alert("Grupo adicionado");
          isLoadingGroup.current = false;
          setUserGroupName(groupInfo?.name);
        },
        onError: () => {
          alert("Falha ao adicionar grupo");
          isLoadingGroup.current = false;
        },
      });
    else {
      isLoadingGroup.current = false;
      alert("Escolha um grupo");
    }
  };

  const createTempModel = (
    fnGetPermission: string | null,
    fnGetUsersJsonFromList: Array<any> | null
  ) => {
    const model = {
      permission: fnGetPermission,
      users: fnGetUsersJsonFromList,
    };
    return model;
  };

  const fetchToggleResendEmail = (user: User, e: any) => {
    let _url: string | undefined = "";
    try {
      _url = copyFunc(
        {
          uid: user.registry,
          cid: user.company_uid,
          acess: user.access_code,
        },
        e,
        true,
        true
      );
    } catch (err) {
      console.log("err", err);
    }

    fetchToggle({
      method: "POST",
      url: API_USER_RESEND_PASSWORD,
      data: {
        company_uid: user.company_uid,
        registry: user.registry,
        access_code: user.access_code,
        url: _url,
      },

      onSuccess: () => {
        setIsEmailSend(user.registry);
        setSending(false);
      },
    });
  };

  const fetchToggleUserDeleteHandler = (user: User) => {
    if (
      window.confirm(
        "TEM CERTEZA QUE DESEJA EXCLUIR PERMANENTEMENTE O USUÁRIO?"
      )
    ) {
      fetchToggle({
        method: "DELETE",
        url: DELETE_API_USERS(String(user.registry)),
        data: {
          user_registry: user.registry,
        },
        onSuccess: () => {
          alert("O USUÁRIO FOI EXCLUIDO!");
          if (user.permission === "01") {
            history(r.R_A_ROOT);
            history(r.R_A_USERS_LIST);
          } else {
            history(r.R_A_ROOT);
            history(r.R_A_USERS_LIST_SMART);
          }
        },
        onError: () => {
          setDeleteErrorMessage(
            "Erro ao excluir usuário. Por favor, tente mais tarde"
          );
        },
      });
    } else {
      alert("A OPERAÇÃO FOI CANCELADA!");
    }
  };

  const fetchToggleUserStatusHandler = (user: User) => {
    // const isActive = h.isTrueFromPythonBoolean(user.active);
    switch (userStatusblock) {
      case true:
        /** BLOQUEIO */
        setuserStatusblock(null);
        fetchToggle({
          method: "POST",
          url: API_USERS_REMOVE,
          data: [{ ...user }],
          onSuccess: () => {
            updateCalback(user, false);
            setuserStatusblock(false);
          },
        });
        break;
      case false:
        /** DESBLOQUEIO */
        setuserStatusblock(null);
        fetchToggle({
          method: "PUT",
          url: API_USERS_ACTIVE,
          data: createTempModel(getUsersJsonPermission(), [{ ...user }]),
          onSuccess: () => {
            updateCalback(user, true);
            setuserStatusblock(true);
          },
        });
        break;
    }
  };

  function sendMail(params: any, e: any) {
    fetchToggleResendEmail(params, e);
    setIsEmailSend(params.registry);
    setSending(true);
  }

  function copyFunc(
    param: any,
    event: any,
    encrypt: boolean,
    getUrl: boolean
  ) {
    if (getUrl) {
      const encryptMessage =
        AUDIOFOCO_LINK +
        "/login?link=" +
        encodeURIComponent(
          Crypto.AES.encrypt(JSON.stringify(param), SECRET_KEY).toString()
        );
      return encryptMessage;
    }
    if (encrypt) {
      const encryptMessage =
        AUDIOFOCO_LINK +
        "/login?link=" +
        encodeURIComponent(
          Crypto.AES.encrypt(JSON.stringify(param), SECRET_KEY).toString()
        );
      navigator.clipboard.writeText(encryptMessage);
      return encryptMessage;
    } else {
      navigator.clipboard.writeText(param);
    }
    const spanElement = event.target.querySelector("span");
    spanElement?.classList?.add(pClasses.copyAnim);
    setTimeout(() => {
      spanElement?.classList?.remove(pClasses.copyAnim);
    }, 1000);
  }

  useEffect(() => {
    if (userInfos) {
      setuserStatusblock(Boolean(userInfos.active));
      setUserGroupName(userInfos?.toolbox?.group_name);
      if (sending) {
        setmailArea(<Spinner extraSmall />);
      } else {
        setmailArea(
          <span>
            <FontAwesomeIcon
              icon={userInfos.registry === isEmailSend ? faCheck : faEnvelope}
            />

            {t("userProfile.send_mail")}
          </span>
        );
      }
    }
  }, [isEmailSend, sending, userInfos]);

  function getPath(user: any) {
    if (user == "10") {
      return R_A_REPORT_SMART;
    } else {
      return r.R_A_REPORT;
    }
  }

  const userStatus =
    userStatusblock != null
      ? t("userProfile.status_" + userStatusblock)
      : t("userProfile.processing");
  useEffect(() => {
    if (groupsUsers) setOptionsGroups(
      groupsUsers?.map((group: any) => {
        if (group.status === "active" && userGroupName !== group.name)
          return (
            <MenuItem key={group.name} value={group.name}>
              {group.name}
            </MenuItem>
          );
      })
    );
  }, [groupsUsers]);

  return (
    <Dialog
      onClose={onCloseModal}
      aria-labelledby="customized-dialog-title"
      open={open}
      className={pClasses.ProfileContainer}
      fullWidth={true}
      maxWidth="md"
    >
      <MuiDialogTitle className={pClasses.top}>
        <Grid
          container
          justifyContent="flex-end"
        >
          <IconButton
            aria-label="close"
            className={pClasses.closeButton}
            onClick={onCloseModal}
            size="small"
          >
            <FontAwesomeIcon
              className={pClasses.icon}
              icon={faTimes}
              size="xs"
            />
          </IconButton>
        </Grid>
        <Grid
          justifyContent="flex-start"
          container
          direction="column"
        >
          <h2 className={pClasses.upper}>
            {userInfos.registry}

            <span
              className={
                userStatusblock
                  ? pClasses.status + " " + pClasses.ativo
                  : pClasses.status + " " + pClasses.inativo
              }
            >
              {userStatus}
              <FontAwesomeIcon
                title={
                  userStatusblock
                    ? t("global.turn_user_off")
                    : t("global.turn_user_on")
                }
                icon={userStatusblock ? faLockOpen : faLock}
              />
            </span>
          </h2>
          {deleteErrorMessage ?? deleteErrorMessage}
          {userInfos.birthdate ? (
            <div style={{ display: "flex", gap: "50px" }}>
              <p>
                {t("global.birthdate_short_label")}: {userInfos.birthdate}
              </p>
            </div>
          ) : null}
          <div>
            {t("userProfile.group_name")}:{" "}
            {userGroupName ? userGroupName : t("global.no_group")}
            <form
              style={{
                display: "flex",
                width: "75%",
                justifyContent: "flex-start",
                alignItems: "center",
                alignContent: "center",
                gap: "10px",
              }}
              onSubmit={(e: any) => {
                insertGroup(e);
              }}
            >
              <div>
                {!userGroupName
                  ? t("global.insert_group")
                  : t("global.change_group")}
                :
              </div>
              <Select
                onChange={(e) => {
                  handlerUserGroup(e.target.value);
                }}
                name="group"
                id="group"
                label={t("global.choose")}
                style={{ width: "25%", marginBottom: "10px" }}
              >
                {optionsGroups}
              </Select>
              <Button
                disabled={isLoadingGroup.current}
                type="submit"
                variant="contained"
                color="primary"
                style={{ height: "25%", margin: "10px 0 10px 10px" }}
              >
                {isLoadingGroup.current
                  ? t("userProfile.loading")
                  : userGroupName
                    ? t("global.change")
                    : t("global.insert")}
              </Button>
            </form>
          </div>
          <p>
            {t("userProfile.acesscode")}:{" "}
            <a
              className={pClasses.primary + " " + pClasses.bold}
              onClick={(event) => copyFunc(userInfos.access_code, event, false, false)}
            >
              {userInfos.access_code}
              <FontAwesomeIcon className={pClasses.copyIcon} icon={faCopy} />
              <span className={pClasses.copyText}>{t("userProfile.copy")}</span>
            </a>
          </p>
          <a
            onClick={(event) =>
              copyFunc(
                {
                  uid: userInfos.registry,
                  cid: userInfos.company_uid,
                  acess: userInfos.access_code,
                },
                event,
                true,
                false
              )
            }
          >
            {t("userProfile.link")}
            <FontAwesomeIcon className={pClasses.copyIcon} icon={faCopy} />
            <span className={pClasses.copyText}>{t("userProfile.copy")}</span>
          </a>
        </Grid>
        <Grid justifyContent="flex-end" container>
          <div className={pClasses.ProfileContainer}>
            {userInfos.is_email ? (
              <span className={pClasses.profileButton}>
                <Button
                  onClick={(e) => sendMail(userProfile.formattedValue, e)}
                  size="small"
                >
                  {mailArea}
                </Button>
              </span>
            ) : null}

            {/* <span className={pClasses.profileButton}>
          <Button
            onClick={() =>
              history(
                getPath(userInfos.permission) +
                  "/" +
                  userInfos.registry +
                  "/" +
                  userInfos.uid
              )
            }
            size="small"
          >
            <span>
              <FontAwesomeIcon icon={faChartBar} />
              {t("userProfile.reports")}
            </span>
          </Button>
        </span> */}
            <span className={pClasses.profileButton}>
              <Button
                onClick={() =>
                  fetchToggleUserStatusHandler(userProfile.formattedValue)
                }
                size="small"
              >
                {userStatusblock != null ? (
                  <FontAwesomeIcon
                    title={
                      !userStatusblock
                        ? t("global.turn_user_off")
                        : t("global.turn_user_on")
                    }
                    icon={!userStatusblock ? faLockOpen : faLock}
                  />
                ) : (
                  <Spinner extraSmall />
                )}

                {!userStatusblock
                  ? t("userProfile.unblock")
                  : t("userProfile.block")}
              </Button>
            </span>
            {userInfos.birthdate != "" &&
              userInfos.permission == "10" ? null : (
              <span className={pClasses.profileButtonError}>
                <Button
                  color="secondary"
                  variant="contained"
                  size="small"
                  disabled={userStatusblock != null ? userStatusblock : true}
                  onClick={() =>
                    fetchToggleUserDeleteHandler(userProfile.formattedValue)
                  }
                >
                  <span>
                    <FontAwesomeIcon icon={faTrashAlt} />
                    {userStatusblock
                      ? t("global.turn_user_off")
                      : t("global.exclude")}
                  </span>
                </Button>
              </span>
            )}
          </div>
        </Grid>
      </MuiDialogTitle>
      <div className={pClasses.journeysInfoButton}>
        <RoundButton
          className={pClasses.infoButtonReports}
          title={t("global.access_reports")}
          onClick={() => {
            history(
              userInfos.permission === "01" ?
                "/admin/report" +
                "/" +
                userInfos.registry +
                "/" +
                userInfos.uid :
                "/admin/smart" +
                "/" +
                userInfos.registry +
                "/" +
                userInfos.uid
            );
          }}
        >
          {t("global.access_reports")}
          {"       "}
          <FontAwesomeIcon icon={faArrowRight} />
        </RoundButton>
      </div>
      {/* <div className={pClasses.journeysInfoContent}>
    <div className={pClasses.journeysInfoContentTitle}>
      <p>
        {t("userProfile.audiofoco_journeys")} ({userInfos.shots})
      </p>
      <JourneyInfoCard userInfos={userInfos} />
    </div>
  </div> */}
      {/* <MuiDialogContent dividers></MuiDialogContent> */}
    </Dialog>
  );
}
